import React, { ComponentProps } from 'react';
import { SearchResults } from '../../types/Search.types';
import { Pagination, PaginationItemWithPageLink } from '../../_lib/components/Pagination';
import { asBlock } from '../../_lib/BlockFetcher';
import { SearchForm } from './partials/SearchForm';
import { BlockType } from '../../types/api/ElementType';
import { FACETS } from '../../components/molecules/ResultListSettings/ResultListSettings.enums';
import { EditorialDashboardResultTable } from './partials/EditorialDashboardResultTable';

type EditorialDashboardProps = SearchResults & {
  pageItems?: PaginationItemWithPageLink[];
};

const editorialDashboardFacets: FACETS[] = [
  FACETS.FQ_ARCHIVEDATE,
  FACETS.FQ_PACKSTATE,
  FACETS.FQ_VALIDDATE,
  FACETS.FQ_RELEVANT_PERSON_NAMES,
  FACETS.FQ_PAGE_CATEGORY_TITLES,
];

export function EditorialDashboard({ pageItems, ...embedded }: EditorialDashboardProps) {
  return (
    <>
      <SearchForm type="content" wantedFacets={editorialDashboardFacets} searchResult={embedded} />
      {embedded && embedded.resultContents && embedded.resultContents.length > 0 ? (
        <EditorialDashboardResultTable items={embedded.resultContents as any} />
      ) : null}
      <Pagination pageItems={pageItems} />
    </>
  );
}

type EditorialDashboardTypes = BlockType.editorialdashboard;
export const EditorialDashboardBlock = asBlock<EditorialDashboardProps, EditorialDashboardTypes>(EditorialDashboard);
export type EditorialDashboardBlock = ComponentProps<typeof EditorialDashboard>;
